<app-header icon="back" backText="_Participants_" title="_EditParticipantDetail_" showNav="false"></app-header>
<div class="quicksearch-detail-page body-container">
  <app-add-edit-participant-detail mode="edit"></app-add-edit-participant-detail>
</div>